import { ZustandMarketingTagsStore } from './types';

export const isMobileAppSelector = (state: ZustandMarketingTagsStore) =>
  state.isRNMobileApp;

export const isValidMobileAppSelector = (state: ZustandMarketingTagsStore) =>
  state.isValidMobileApp;
